export default class FiltroPedidosExpedidosFaturados{
    constructor () {
        this.CodigoProduto = undefined;
        this.NomeProduto = undefined;
        this.NomeProdutoNovo = undefined;
        this.ClienteId= undefined;
        this.RepresentanteId = undefined;
        this.UnidadeId= undefined;
        this.PeriodoInicio = undefined;
        this.PeriodoFim = undefined;        
        this.ConsultarDadosClienteAgrupador = undefined;
        this.NumeroOrdemDeCompra = undefined;
        this.NumeroPedido = undefined;
    }
}